function ErrorButton() {
  return (
    <button
      onClick={() => {
        throw new Error('This is your first error!');
      }}
    >
      Break the world
    </button>
  );
}

export default function Demo() {
  return <div><ErrorButton /></div>
}
